export default __webpack_public_path__ + "static/media/no-results.8b106f03.svg";